export const UNEXPECTED_ERROR = {
  en_US: 'An unexpected error has occurred.',
  pt_BR: 'Ocorreu um erro inesperado.',
  es_ES: 'Ha ocurrido un error inesperado.',
};
